/*!
 * devextreme-vue
 * Version: 24.1.7
 * Build date: Wed Oct 30 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

const DX_TEMPLATE_WRAPPER_CLASS = 'dx-template-wrapper';
const DX_REMOVE_EVENT = 'dxremove';
export { DX_TEMPLATE_WRAPPER_CLASS, DX_REMOVE_EVENT, };
